import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cell" }
const _hoisted_2 = { class: "cell" }
const _hoisted_3 = { class: "cell" }
const _hoisted_4 = { class: "cell" }
const _hoisted_5 = { class: "cell" }
const _hoisted_6 = { class: "cell" }
const _hoisted_7 = { class: "cell" }
const _hoisted_8 = { class: "cell" }
const _hoisted_9 = { class: "cell" }
const _hoisted_10 = { class: "cell" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("table", {
    class: "el-year-table",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleYearTableClick && _ctx.handleYearTableClick(...args)))
  }, [
    _createElementVNode("tbody", null, [
      _createElementVNode("tr", null, [
        _createElementVNode("td", {
          class: _normalizeClass(["available", _ctx.getCellStyle(_ctx.startYear + 0)])
        }, [
          _createElementVNode("a", _hoisted_1, _toDisplayString(_ctx.startYear), 1)
        ], 2),
        _createElementVNode("td", {
          class: _normalizeClass(["available", _ctx.getCellStyle(_ctx.startYear + 1)])
        }, [
          _createElementVNode("a", _hoisted_2, _toDisplayString(_ctx.startYear + 1), 1)
        ], 2),
        _createElementVNode("td", {
          class: _normalizeClass(["available", _ctx.getCellStyle(_ctx.startYear + 2)])
        }, [
          _createElementVNode("a", _hoisted_3, _toDisplayString(_ctx.startYear + 2), 1)
        ], 2),
        _createElementVNode("td", {
          class: _normalizeClass(["available", _ctx.getCellStyle(_ctx.startYear + 3)])
        }, [
          _createElementVNode("a", _hoisted_4, _toDisplayString(_ctx.startYear + 3), 1)
        ], 2)
      ]),
      _createElementVNode("tr", null, [
        _createElementVNode("td", {
          class: _normalizeClass(["available", _ctx.getCellStyle(_ctx.startYear + 4)])
        }, [
          _createElementVNode("a", _hoisted_5, _toDisplayString(_ctx.startYear + 4), 1)
        ], 2),
        _createElementVNode("td", {
          class: _normalizeClass(["available", _ctx.getCellStyle(_ctx.startYear + 5)])
        }, [
          _createElementVNode("a", _hoisted_6, _toDisplayString(_ctx.startYear + 5), 1)
        ], 2),
        _createElementVNode("td", {
          class: _normalizeClass(["available", _ctx.getCellStyle(_ctx.startYear + 6)])
        }, [
          _createElementVNode("a", _hoisted_7, _toDisplayString(_ctx.startYear + 6), 1)
        ], 2),
        _createElementVNode("td", {
          class: _normalizeClass(["available", _ctx.getCellStyle(_ctx.startYear + 7)])
        }, [
          _createElementVNode("a", _hoisted_8, _toDisplayString(_ctx.startYear + 7), 1)
        ], 2)
      ]),
      _createElementVNode("tr", null, [
        _createElementVNode("td", {
          class: _normalizeClass(["available", _ctx.getCellStyle(_ctx.startYear + 8)])
        }, [
          _createElementVNode("a", _hoisted_9, _toDisplayString(_ctx.startYear + 8), 1)
        ], 2),
        _createElementVNode("td", {
          class: _normalizeClass(["available", _ctx.getCellStyle(_ctx.startYear + 9)])
        }, [
          _createElementVNode("a", _hoisted_10, _toDisplayString(_ctx.startYear + 9), 1)
        ], 2),
        _hoisted_11,
        _hoisted_12
      ])
    ])
  ]))
}